var __WEBPACK_NAMESPACE_OBJECT__ = {"publicPath":"/","swarmApiUrl":"/api","swarmWsUrl":"wss://ghidohome.no-ip.org/ws"};